import i18n from 'config/i18n';
import dayjs, { Dayjs } from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

dayjs.extend(minMax);

const connectSelfmatchDutiesSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    startDate: yup
      .mixed<Dayjs>()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      )
      .required(),
    endDate: yup
      .mixed<Dayjs>()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      )
      .test(
        'dayjs-min',
        () =>
          t('dateRangeMismatch', {
            startDate: t('startDate'),
            endDate: t('endDate')
          }),
        (v, ctx) => {
          const validFrom = ctx.parent.validFrom as Dayjs;
          return v && validFrom ? v.isAfter(validFrom) : true;
        }
      )
      .required()
  });
};

export default connectSelfmatchDutiesSchema;
